import { Routes } from '@angular/router';
import { permisoGuard } from '../core/auth/permiso.guard';
import { Permiso } from '../core/auth/permisos';

export const resultadosRoutes: Routes = [
  {
    path: 'resultados/revision',
    canActivate: [permisoGuard],
    data: { permiso: Permiso.REVISION_VER },
    loadComponent: () =>
      import('./pages/revision-resultados/revision-resultados.page').then(
        (m) => m.RevisionResultadosPage,
      ),
    title: 'SiLabVet | Revisión de resultados',
  },
  {
    path: 'resultados/revision/:pantalla/:recepcionId',
    canActivate: [permisoGuard],
    data: { permiso: Permiso.REVISION_VER },
    loadComponent: () =>
      import('./pages/revision-detalle/revision-detalle.page').then((m) => m.RevisionDetallePage),
    title: 'SiLabVet | Revisión de informe',
  },
];
